import { getContent } from "../../../../../dependencies/getContent/dev";
import { submitPayment } from "../../../../../dependencies/submitPayment/dev";
import { getIsMobile } from "../../../../../dependencies/getIsMobile/dev";
import { getUserAccountInfo } from "../../../../../dependencies/getUserAccountInfo/dev";
import { setUserAccountInfo } from "../../../../../dependencies/setUserAccountInfo/dev";
import { getIsBeelineError } from "../../PaymentSelection/components/PaymentDetailsSection/InputSection/components/PhoneInput/dependencies/getIsBeelineError/dev";
import { getMapStateToEmailPopupProps } from "./logic/logic";
export { EmailPopup } from "./EmailPopup";
export var mapStateToEmailPopupProps = getMapStateToEmailPopupProps({
  getContent: getContent,
  submitPayment: submitPayment,
  getIsBeelineError: getIsBeelineError,
  getIsMobile: getIsMobile,
  getUserAccountInfo: getUserAccountInfo,
  setUserAccountInfo: setUserAccountInfo
});